/*
  Mirrored vocabulary for the admin activity log.

  These enums originate in the backend (enums/environment.enum.ts, enums/activityLog.enum.ts) and
  are mirrored here under identical names — the values must match exactly, because the CMS sends
  them back as query filters. Labels are display-only and live beside them so the tables and the
  filter bar cannot disagree about what a value is called.
*/

export const ENVIRONMENT = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  UAT: 'uat',
  PRODUCTION: 'production',
  UNKNOWN: 'unknown',
  UNRECOGNISED: 'unrecognised'
};

export const ENVIRONMENT_LABELS = {
  development: 'DEV',
  staging: 'STAGE',
  uat: 'UAT',
  production: 'PROD',
  unknown: 'Not configured',
  unrecognised: 'Misconfigured'
};

/** An environment that is not a real declaration — worth showing as a fault, not a value. */
export const isEnvironmentFaulty = (env) =>
  env === ENVIRONMENT.UNKNOWN || env === ENVIRONMENT.UNRECOGNISED;

export const CALL_OUTCOME = { SUCCESS: 'success', FAILURE: 'failure' };

export const RUN_OUTCOME = {
  IN_PROGRESS: 'in_progress',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  INDETERMINATE: 'indeterminate'
};

export const RUN_OUTCOME_LABELS = {
  in_progress: 'Running',
  succeeded: 'Succeeded',
  failed: 'Failed',
  indeterminate: 'Never reported'
};

export const ERROR_CATEGORY_LABELS = {
  timeout: 'Timeout',
  network_error: 'Network Error',
  client_error: '4xx Client Error',
  server_error: '5xx Server Error',
  validation_error: 'Validation Error',
  quota_exceeded: 'Quota Exceeded',
  provider_error: 'Provider Error'
};

export const FEATURE_LABELS = {
  match_feed_poll: 'Match Feed Poller',
  game_import: 'Game Import',
  fanwave: 'FanWave',
  goalrush: 'GoalRush',
  poll: 'Poll',
  quiz: 'Quick Quiz',
  predictions: 'Predictions',
  player_of_the_match: 'Player of the Match',
  live_score_push: 'Live Score Push',
  glory_board: 'Glory Board',
  streak: 'Streak',
  team_channel: 'Team Channel',
  billing: 'Billing',
  moderation: 'Moderation',
  notifications: 'Notifications',
  admin: 'Admin',
  unattributed: 'Unattributed'
};

export const SERVICE_LABELS = { match_data: 'Match Data Provider' };

export const PROJECTION_UNAVAILABLE_LABELS = {
  no_allowance: 'No allowance to project against',
  rate_too_low: 'Rate too low to project',
  already_exhausted: 'Allowance already spent'
};

export const featureLabel = (v) => FEATURE_LABELS[v] || v || '—';
export const serviceLabel = (v) => SERVICE_LABELS[v] || v || '—';
export const environmentLabel = (v) => ENVIRONMENT_LABELS[v] || v || '—';
export const runOutcomeLabel = (v) => RUN_OUTCOME_LABELS[v] || v || '—';
export const errorCategoryLabel = (v) => (v ? ERROR_CATEGORY_LABELS[v] || v : '—');
